export default {
  install(Vue) {
    // Load Beacon script
    (function (e, t, n) {
      function a() {
        var e = t.getElementsByTagName("script")[0],
          n = t.createElement("script");
        n.type = "text/javascript";
        n.async = true;
        n.src = "https://beacon-v2.helpscout.net";
        e.parentNode.insertBefore(n, e);
      }
      if (
        ((e.Beacon = n =
          function (t, n, a) {
            e.Beacon.readyQueue.push({ method: t, options: n, data: a });
          }),
        (n.readyQueue = []),
        t.readyState === "complete")
      )
        return a();
      e.attachEvent
        ? e.attachEvent("onload", a)
        : e.addEventListener("load", a, false);
    })(window, document, window.Beacon || function () {});

    // Init with your Beacon ID (retry until loaded)
    const initBeacon = () => {
      if (window.Beacon) {
        window.Beacon("init", "62587dcc-fff6-4120-a4de-71590d69f06f"); // <-- your ID
      } else {
        setTimeout(initBeacon, 500);
      }
    };
    initBeacon();

    Vue.prototype.$beacon = (...args) =>
      window.Beacon && window.Beacon(...args);
  },
};
